import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { KeySellingPointData, TitleInfo } from '../../../common/interfaces';
import { TextAlignment } from '../../../common/enums';

const DEFAULT_ICON_SIZE = 60;
const DEFAULT_TITLE_FONT_SIZE = 32;
const DEFAULT_SUBTITLE_FONT_SIZE = 24;
const DEFAULT_TEXT_TITLE_FONT_SIZE = 20;
const DEFAULT_TEXT_VALUE_FONT_SIZE = 16;
const MIN_FONT_SIZE = 8;
const TEXT_TITLE_VALUE_DIFFERENCE = 4;
const MOBILE_TITLE_RATIO = 2 / 3;
const MOBILE_TEXT_DIFFERENCE = 4;
const MOBILE_TEXT_TITLE_VALUE_DIFFERENCE = 2;

@Component({
    selector: 'vsf-key-selling-points-banner',
    templateUrl: './key-selling-points-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeySellingPointsBannerComponent implements OnInit {
    @Input() iconSize?: number;
    @Input() keySellingPoints: KeySellingPointData[] = [];
    @Input() layout: 'horizontal' | 'vertical' = 'horizontal';
    @Input() mobileLayout: 'horizontal' | 'vertical' = 'horizontal';
    @Input() backgroundColor: string = '#ffffff';
    @Input() textColor: string = '#000000';
    @Input() isMobile: boolean = false;
    @Input() linePadding: string;
    @Input() sectionRoundedClass: string = '';
    @Input() titleFontSize?: number;
    @Input() subtitleFontSize?: number;
    @Input() textFontSize?: number;
    @Input() listLayout: 'horizontal' | 'vertical' = 'horizontal';
    @Input() separatedBackground: boolean = false;
    @Input() titleAlignment: TextAlignment = TextAlignment.Center;
    @Input() textAlignment : TextAlignment = TextAlignment.Left;
    @Input() titleInfo: TitleInfo | null = null;

    gridTemplateColumns: string = '';
    iconSizePx = `${DEFAULT_ICON_SIZE}px`;
    titleFontPx = DEFAULT_TITLE_FONT_SIZE;
    subtitleFontPx = DEFAULT_SUBTITLE_FONT_SIZE;
    kpTitleFontPx = DEFAULT_TEXT_TITLE_FONT_SIZE;
    kpValueFontPx = DEFAULT_TEXT_VALUE_FONT_SIZE;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
      this.refreshDerived();
      if (this.isMobile)  {
        this.layout = this.mobileLayout;
      }
      if(this.layout === 'horizontal') {
        this.textAlignment = TextAlignment.Left;
      }
    }

    private refreshDerived(): void {
      this.iconSizePx = this.toPx(this.iconSize, DEFAULT_ICON_SIZE);

      const dTitle = this.titleFontSize ?? DEFAULT_TITLE_FONT_SIZE;
      const dSub = this.subtitleFontSize ?? DEFAULT_SUBTITLE_FONT_SIZE;
      const dText = this.textFontSize ?? DEFAULT_TEXT_TITLE_FONT_SIZE;

      this.titleFontPx    = this.isMobile ? Math.round(dTitle * MOBILE_TITLE_RATIO) : dTitle;
      this.subtitleFontPx = this.isMobile ? Math.round(dSub   * MOBILE_TITLE_RATIO) : dSub;
      this.kpTitleFontPx  = this.isMobile ? Math.max(MIN_FONT_SIZE , dText - MOBILE_TEXT_DIFFERENCE): dText;
      this.kpValueFontPx  = this.isMobile ?
        Math.max(MIN_FONT_SIZE , dText - MOBILE_TEXT_DIFFERENCE - MOBILE_TEXT_TITLE_VALUE_DIFFERENCE) :
        Math.max(MIN_FONT_SIZE , dText - TEXT_TITLE_VALUE_DIFFERENCE) ;

      this.cdr.markForCheck();
    }

    private toPx(v: number | undefined, fallback: number): string {
      const n = Number(v);
      return n > 0 ? `${n}px` : `${fallback}px`;
    }
}
